import script from "./CitizenForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CitizenForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__